import type {
  ContestHandover,
  ContestViewContest,
  ContestViewEntry,
} from '@freelancer/datastore/collections';
import type { Observable } from 'rxjs';

export class ContestHandoverFilesModalResponse {
  openProvideFeedbackModal: boolean;
}

export enum HandoverStatus {
  STATIC = 0,
  CONTRACT_NOT_SIGNED = 1,
  CONTRACT_SIGNED = 2,
  FILES_TRANSFERRED = 3,
  COMPLETE = 4,
}

export interface ContestHandoverFilesModalInput {
  contest$: Observable<ContestViewContest>;
  entry$: Observable<ContestViewEntry | undefined>;
  handover$: Observable<ContestHandover | undefined>;
  loggedInUserId$: Observable<number>;
  isReviewComplete$: Observable<boolean>;
}
